import {MTPLTarrifficationForm} from "./forms/MtplTarrifficationForm";
import {MTPLPersonalInfoForm} from "./forms/MTPLPersonalInfoForm/MtplPersonalInfoForm";
import {MtplVerificationForm} from "./forms/MtplVerificationForm";
import {MTPLTarrifficationFormSmartDrive} from "./forms/MtplTarrifficationFormSmartDrive";
import {GreenTarrifficationForm} from "./green_forms/GreenTarrifficationForm";
import {GreenPersonalInfoForm} from "./green_forms/GreenPersonalInfoForm/GreenPersonalInfoForm";
import {GreenVerificationForm} from "./green_forms/GreenVerificationForm";

export const forms: any = {
    "mtplTarifficationStep": MTPLTarrifficationForm,
    "mtplTarifficationStepSmartDrive": MTPLTarrifficationFormSmartDrive,
    "mtplGeneralContractStep": MTPLPersonalInfoForm,
    "dataVerificationStep": MtplVerificationForm,
    "greenCardTarifficationStep": GreenTarrifficationForm,
    "greenCardGeneralContractStep": GreenPersonalInfoForm,
    "greenCardDataVerificationStep": GreenVerificationForm
};